export default __webpack_public_path__ + "static/media/pic3.38827688.jpg";